
const mantenedoresState = {
  isLoading: false,
  isLoadingRoles: false,
  roles: [],
  perfiles: [],
  empresas: [],
  functionalities: [],
  selectedFuncionalities: null,
  filtrosTablaRoles: null,
  filtrosTablaPerfiles: null,
  eventDataRol: null,

};

export default mantenedoresState;
